import {
  AfterViewChecked,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  ViewEncapsulation,
  ChangeDetectionStrategy
} from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  DxButtonModule,
  DxHtmlEditorModule,
  DxPopupModule,
  DxResizableModule,
  DxScrollViewModule,
  DxSortableModule,
  DxTextBoxModule,
  DxToastModule,
  DxValidationGroupModule,
  DxValidatorModule,
} from "devextreme-angular";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { WikiService } from "src/app/services/wiki.service";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import { SharedPipesModule } from "../../../pipes/shared.pipes.module";
import { AppGlobals } from "src/app/app.globals";
import { environment } from "src/environments/environment";
import { AddEvent, ReorderEvent } from "devextreme/ui/sortable";
import { forEach } from "jszip";
import { ContentReadyEvent } from "devextreme/ui/html_editor";
import { DeletePopupComponent } from "src/app/components/delete-popup/delete-popup.component";
import { ScrollableService } from "src/app/services/misc/scrollable.service";
import dxValidationGroup from "devextreme/ui/validation_group";
import { GpdButtonComponent } from "src/app/components/gpd-button/gpd-button.component";



interface Article {
  id: number | undefined;
  title: string | undefined;
  paragraphs: Array<Paragraph> | undefined;
}

interface Paragraph {
  id: string | undefined;
  blocks: Array<Block> | undefined;
  open: boolean | undefined;
}

interface Block {
  id: string | undefined;
  type: string | undefined;
  content: string | undefined;
  contentHeight: number | undefined;
  contentWidth: number | undefined;
}

interface CurrentFile {
  paragraphId: number | undefined;
  file: any;
}

@Component({
    selector: "app-wiki-edit",
    templateUrl: "./wiki-edit.component.html",
    styleUrls: ["./wiki-edit.component.css"],
    imports: [
        CommonModule,
        DxScrollViewModule,
        DxToastModule,
        DxSortableModule,
        DxButtonModule,
        DxPopupModule,
        DxHtmlEditorModule,
        DxTextBoxModule,
        DxResizableModule,
        SharedPipesModule,
        RouterLink,
        DeletePopupComponent,
        DxValidationGroupModule,
        DxValidatorModule,
        GpdButtonComponent,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    encapsulation: ViewEncapsulation.None
})
export class WikiEditComponent implements OnInit, AfterViewChecked {
  @ViewChild("fileInput") fileInput: ElementRef;
  wikiSection: string;
  forbiddenPattern = /^[^<>:"/\\?*\x00]+$/;
  titleForbiddenMessage = $localize`:@@forbiddenCharacters:Filenames cannot contain <>:"/\?* or null characters.`;

  type: any = "";
  message: any = "";
  toastTwoVisible: boolean = false;
  disableEdit: boolean = false;
  article: Article = {
    id: 0,
    title: "",
    paragraphs: new Array<Paragraph>(),
  };

  blockOptions = [
    {
      text: $localize`:@@textblock:Textblock`,
      icon: "font",
      onClick: () => this.createBlock("text"),
    },
    {
      text: $localize`:@@image:Image`,
      icon: "image",
      onClick: () => this.createBlock("image"),
    },
    // { text: $localize`:@@pdfPreview:PDF-Preview`, icon: 'pdffile', onClick: () => this.createBlock('pdf') }
  ];

  newBlockPopupVisible: boolean = false;

  newId = 0;

  toastVisible: boolean = false;

  currentFile: CurrentFile;
  currentParagraph: Paragraph;
  currentBlock: Block;

  articleId: any;

  pageBreadCrumb: any = {
    text: $localize`Wiki/`,
    href: window.location.href,
    layer: 0,
  };

  deletePopupVisible: boolean = false;
  deletePopupMessage: any = $localize`Are you sure you want to delete this Article?`;

  constructor(
    private wikiService: WikiService,
    private activatedRoute: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private router: Router,
    private appGlobals: AppGlobals,
    private scrollableService: ScrollableService
  ) {
    this.wikiSection = router.url.split("/")[2];
    window.onbeforeunload = null;
  }

  ngOnInit(): void {
    /*    if (environment.isTestEnvironment === true) { */
    this.appGlobals.SetGlobalMenuIndex(8);
    /*     } else {
      this.appGlobals.SetGlobalMenuIndex(6);
    } */

    let articleId = this.activatedRoute.snapshot.params.id;

    this.articleId = articleId;

    if (!this.canEditWiki())
      this.router.navigate([`/wiki/${this.wikiSection}/` + this.articleId]);

    if (articleId != 0) {
      this.wikiService
        .getWikiArticle({
          WikiArticleRequestItem: { Id: this.articleId },
          WikiSection: this.wikiSection,
        })
        .then(
          (result) => {
            if (result.hasError === true)
              AppGlobals.ShowErrorMessage(result.feedback);
            else {
              this.article = result.wikiArticleItem.article;
              this.article.paragraphs?.forEach((paragraph) => {
                paragraph.open = false;
              });

              AppGlobals.SetEditWarningStatus(true);
            }
          },
          (error: any) => {
            AppGlobals.ShowErrorMessage(error);
          }
        );
    } else {
      this.createParagraph();
      this.createBlock("text");
    }

    this.currentFile = {
      paragraphId: 0,
      file: null,
    };
  }

  @ViewChild("wikieditscrollableDiv", { static: false })
  scrollableDiv: ElementRef;
  hasInitialized = false;
  ngAfterViewChecked(): void {
    if (!this.hasInitialized && this.scrollableDiv) {
      this.scrollableService.setScrollableElement(this.scrollableDiv);
      this.hasInitialized = true;
    }
  }

  showNewParagraphPopup(paragraphId) {
    this.currentParagraph = paragraphId;
    this.newBlockPopupVisible = true;
  }

  async saveParagraph(block) {
    switch (block.type) {
      case "text":
        break;
      case "image":
        block.content = `<img src="${this.currentFile.file}">`;
        break;
      case "pdf":
        block.content = `<iframe src="${this.currentFile.file}" style="width: 70%; height: 550px;"> </iframe>`;
        break;
    }

    this.currentFile = {
      paragraphId: null,
      file: null,
    };

    this.currentBlock = null;
  }

  createParagraph() {
    let paragraph: Paragraph = {
      id: this.generateGUID(),
      blocks: [],
      open: true,
    };
    this.article.paragraphs.push(paragraph);
  }

  deleteParagraph(paragraphId) {
    let indexParagraph = this.article.paragraphs.findIndex(
      (item) => item.id == paragraphId
    );

    if (indexParagraph != -1) {
      this.article.paragraphs.splice(indexParagraph, 1);
    }

    this.currentFile = {
      paragraphId: null,
      file: null,
    };
  }

  createBlock(type) {
    this.currentFile = {
      paragraphId: null,
      file: null,
    };

    let block: Block = {
      id: this.generateGUID(),
      type: type,
      content: null,
      contentWidth: null,
      contentHeight: null,
    };
    this.currentParagraph.blocks.push(block);
    this.currentBlock = block;
    this.newBlockPopupVisible = false;
  }

  editBlock(block) {
    this.currentBlock = block;
  }

  deleteBlock(paragraphId, blockId) {
    let indexParagraph = this.article.paragraphs.findIndex(
      (item) => item.id == paragraphId
    );
    let indexBlock = this.article.paragraphs[indexParagraph].blocks.findIndex(
      (item) => item.id == blockId
    );

    if (indexParagraph != -1 && indexBlock != -1) {
      this.article.paragraphs[indexParagraph].blocks.splice(indexBlock, 1);
    }

    this.currentFile = {
      paragraphId: null,
      file: null,
    };
  }

  onEditorInitialized(e: ContentReadyEvent) {
    setTimeout(() => {
      e.component.focus();
    }, 1000);
  }

  async onFileChanged(file, paragraph) {
    this.currentFile = {
      paragraphId: paragraph.id,
      file: await this.getBase64(file),
    };
    this.saveParagraph(paragraph);
  }

  getBase64(file) {
    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        resolve(reader.result);
      };

      reader.onerror = function (error) {
        reject(error);
      };
    });
  }

  triggerFileInput(e) {
    e.stopPropagation();
    this.currentFile = {
      paragraphId: null,
      file: null,
    };
    this.fileInput.nativeElement.click();
  }

  getSafeHTML() {
    return this.sanitizer.bypassSecurityTrustHtml(
      `<iframe src="${this.currentFile.file}" style="width: 70%; height: 550px;"> </iframe>`
    );
  }

  saveArticle() {
    let WikiArticleItem = {
      article: this.article,
    };

    WikiArticleItem.article.id = this.articleId;
    WikiArticleItem.article.paragraphs.forEach(
      (p) => (p.blocks = p.blocks.filter((p) => p.content != null))
    );
    WikiArticleItem.article.paragraphs =
      WikiArticleItem.article.paragraphs.filter((p) => p.blocks.length > 0);

    this.wikiService
      .saveWikiArticle({
        WikiArticleItem: WikiArticleItem,
        WikiSection: this.wikiSection,
      })
      .then(
        (result) => {
          if (result.hasError === true)
            AppGlobals.ShowErrorMessage(result.feedback);
          else {
            this.toastVisible = true;

            if (result.resultDataInt) {
              this.articleId = result.resultDataInt;
              this.article.id = result.resultDataInt;
            } else
              AppGlobals.ShowErrorMessage(
                "Article might not have saved properly."
              );
          }
        },
        (error: any) => {
          AppGlobals.ShowErrorMessage(error);
        }
      );
  }

  deletePopupShow() {
    this.deletePopupVisible = true;
  }

  deleteArticle() {
    if (this.article.id != 0) {
      this.wikiService
        .deleteWikiArticle({ WikiArticleRequestItem: { Id: this.articleId }, WikiSection: this.wikiSection })
        .then(
          (result) => {
            if (result.hasError === true)
              AppGlobals.ShowErrorMessage(result.feedback);
            else {
              this.navigateToMainPage();
              this.saveToast({
                type: true,
                feedback: $localize`:@@deleted:Deleted`,
              });
            }
          },
          (error: any) => {
            AppGlobals.ShowErrorMessage(error);
          }
        );
    } else {
      this.article.title = "";
    }
  }

  generateGUID() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }

  navigateToMainPage() {
    this.router.navigate(["/wiki/" + this.wikiSection]);
    AppGlobals.setBreadCrumbToLocalStorage(this.pageBreadCrumb);
  }

  saveToast(e: any): void {
    const type = e.type ? "success" : "error";
    if ((this.type = "success")) {
      this.message = e.feedback;
    } else {
      AppGlobals.ShowErrorMessage(
        $localize`:@@errorTryAgain:ERROR: There was an error, please try again.`
      );
    }
    this.type = type;
    this.toastVisible = true;
  }

  onDrop(event: any, data: any, filetype: string) {
    event.preventDefault();
    const files = event.dataTransfer.files;
    const file = files.length > 0 ? files[0] : null;
    if (file) {
      if (filetype === "image" && file.type.includes("image")) {
        this.onFileChanged(file, data);
      } else if (filetype === "pdf" && file.type === "application/pdf") {
        this.onFileChanged(file, data);
      } else {
        // Optionally show an error message
      }
    }
  }
  onDragOver(event: any) {
    event.preventDefault();
  }

  onParagraphReorder(e: ReorderEvent) {
    console.log(e);

    const paragraph = this.article.paragraphs[e.fromIndex];
    this.article.paragraphs.splice(e.fromIndex, 1);
    this.article.paragraphs.splice(e.toIndex, 0, paragraph);
  }

  onBlockDrop(e: AddEvent) {
    const block = e.fromData.blocks[e.fromIndex];
    e.fromData.blocks.splice(e.fromIndex, 1);
    e.toData.blocks.splice(e.toIndex, 0, block);
  }

  onBlockReorder(e: ReorderEvent) {
    console.log(e);
    let paragraphIndex = this.article.paragraphs.findIndex(
      (item) => item.id == e.fromData.id
    );
    let fromBlock = this.article.paragraphs[paragraphIndex].blocks[e.fromIndex];
    this.article.paragraphs[paragraphIndex].blocks.splice(e.fromIndex, 1);
    this.article.paragraphs[paragraphIndex].blocks.splice(
      e.toIndex,
      0,
      fromBlock
    );
  }

  canEditWiki(): boolean {
    if (this.wikiSection == "manual") {
      const email: string = AppGlobals.LoggedInUserData.email;
      if (!email.includes("@tdc.co.za") && !email.includes("@gp-digital.io")) {
        return false;
      }
    }
    return AppGlobals.UserPermissions.canEdit === true;
  }

  getBackLink(): string {
    // If article exists (has an id and a non-empty title), go to the article
    if (this.articleId && this.article.title && this.article.title.trim() !== '') {
      return `/wiki/${this.wikiSection}/${this.articleId}`;
    }
    // Otherwise, go to the main wiki section page
    return `/wiki/${this.wikiSection}`;
  }
}
